import axios from 'axios';
import dayjs, { Dayjs } from 'dayjs';
import { useCallback } from 'react';
import { Setting } from '../App';
import { CUSTOMER_API_URL } from '../constants';
import { SubscriptionDetail, Summary } from './use-subscription-summary';

export const useUpdateDeliveryDate = (
  setting: Setting,
  subscription: SubscriptionDetail | undefined,
  summary: Summary | undefined,
  success: () => void,
  failed?: (message: string) => void
) => {

  const updateDeliveryDate = useCallback((
    date: Date | undefined, 
    time: string | undefined,
  ) => {
    (async () => {
      if (!setting.token || !subscription || !summary || !success) return;
      if (!date || !time) return;

      try {
        // nextBillingDate と deliveryDate を追加
        const nextBillingDate = dayjs(date).subtract(subscription.shop.deliveryDays, 'day');
        const deliveryDate = formatDeliveryDateFromDayjs(date);

        const params = {
          subscriptionId: subscription.subscriptionContractId,
          deliveryDays: dayjs(date).diff(dayjs(summary.nextBillingDate), 'day'),
          deliveryTime: time,
          nextBilling: nextBillingDate,
          deliveryDate: deliveryDate,
        } as {
          subscriptionId: string,
          deliveryDays: number,
          deliveryTime: string,
          nextBilling?: Dayjs,
          deliveryDate?: string
        };

        // お届け日時変更に合わせて注文日も更新する、にチェックが入っている場合
        if (subscription.shop.changeNextBillingDateWithDeliveryDate) {
          if (!summary.nextDeliveryDate) return;
          params.nextBilling = nextBillingDate;
          params.deliveryDays = (subscription.deliveryDays === -1 && subscription.shop.enableDeliveryDateNoDay)
            ? -1 : subscription.shop.deliveryDays;
          params.deliveryDate = formatDeliveryDateFromDayjs(summary.nextDeliveryDate);
        }

        await axios.post(
          `${CUSTOMER_API_URL}?action=updateDeliveryDays`,
          params,
          {
            headers: { Authorization: setting.token },
          }
        );
        success();
      } catch (e) {
        if (failed) {
          failed(e.message);
        }
      }
    })();
  }, [setting.token, subscription, summary, success, failed]);

  return { updateDeliveryDate };
};

const formatDeliveryDateFromDayjs = (date: dayjs.Dayjs | Date) => {
  return dayjs.isDayjs(date)
    ? date.format('YYYY年M月D日') 
    : dayjs(date).format('YYYY年M月D日');
}